import React, {Component} from 'react';
import KPI from 'components/Dashboard/Kpi';
import jwt_decode from "jwt-decode";
import ColumnChart from 'components/amcharts/ColumnChart';
import LineChart from 'components/amcharts/LineChart';
import PieChart from 'components/amcharts/PieChart';
import StackedColumnChart from 'components/amcharts/StackedColumnChart';
//import AreaChart from 'components/amcharts/AreaChart';
//import BubbleChart from 'components/amcharts/BubbleChart';
import BarChart from 'components/amcharts/BarChart';
import PieofPieChart from 'components/amcharts/PieOfPieChart';
import axios from "axios";
import config from "react-global-configuration";
import $ from "jquery";
//import {parse} from "query-string";
//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from "moment";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import Select from 'react-select';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
//import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const queryString = require('query-string');
var yesterday = new Date(Date.now() - 24*60*60*1000);
var yestSend = moment(yesterday).format('YYYY-MM-DD');

var todayDate = new Date();
var minDate = new Date('2020-01-01');
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
var start_date_limit = moment(minDate).format('MM/DD/YYYY');

function numDifferentiation(val) {
    if(val >= 10000000) val = (val/10000000).toFixed(2) + ' Cr';
    else if(val >= 100000) val = (val/100000).toFixed(2) + ' Lakh';
    else if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
    return val;
}
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

const month_render =[
    {label:"February 2020",value:2},
    {label:"March 2020",value:3},
];

const brand_render =[
    {label:"XIAOMI",value:5}
];



class NewDashboard extends Component {
    state = {
        kpiData: [],
        chartHeight: "250px",
        dashbordDetail: [],
        chart_data: [],
        divWidth: '',
        startDate:yestSend,
        merchant_list_box: false,
        chain_list_box: false,
        store_list_box: false,
        acq_bank_list_box: false,
        dateTo:tod,
        dateLimit:date_limit,
        dateFromLimit: start_date_limit,
        dateToShow:todShow,
        todSend:todSend,
        yestSend:yestSend,
        datefrom:yest,
        datefromShow:yestShow,
        merchantList:[{label:"Innoviti Payment Solutions Pvt. Ltd.",value:5}],
        chainList:[{label:"Merchantposblr", value:6}],
        merchantID:'',
        chainID:'',
        storeID:'',
        merchantValue:null,
        chainValue:null,
        storeList:[],
        acqBankList:[],
        acqBankValue: null,
        acqBankIds:'',
        dashId:'',
        last_updated:'',
        selected_category: null,
        selected_category_value: [],
        selected_product: null,
        selected_product_value: [],
        default_month: {label:"February 2020",value:2},
        category_list: [],
        emi_tenure_values: [],
        cust_acq_values: [],
        product_list: [],
        party_master_id: null,
        party_master_name: null,
        selected_merchant: null,
        selected_merchant_value: [],
        selected_chain: null,
        selected_chain_value: [],
        selected_brand: null,
        selected_brand_value: [],
        merchant_list: [],
        default_brand: {label:"XIAOMI",value:5},
        default_month: {label:"February 2020",value:2},
        selected_month: 2,
        sales_value: null,
        cashback_value: null,
        success_value: null,
        failure_value: null,
        emi_tenure_values: [],
        cust_acq_values: []
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        

        var parsed = queryString.parse(this.props.location.search);
        let dashId = parsed.dashId;
        this.get_dashboard_type(dashId);
        this.setState({
            dashId:dashId
        })
        if (decoded.userGroup == 1 || decoded.userGroup == '1'){
            this.setState({
                party_master_id: 5,
                loading: false,
                user_id: decoded._id
            }, ()=>{
                this._get_acq_banks();
                this.generateCategory();
                this.generateMerchant();
                this.getSalesValue();
                this.getCashbackValue();
                this.generateChart();
                this.generateChart2();
            })
        }
        else{
            this.getPartyID();
        }
        
    }


    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            
            //this._getAllMerchants();
            this._get_acq_banks();
            this.generateCategory();
            this.generateMerchant();
            this.getSalesValue();
            this.getCashbackValue();
            this.generateChart();
            this.generateChart2();
        });
    }

    
    generateChart(){
        axios.post(config.get('API_URL') + '/brandemi/get_emi_tenure_values',{
            month: this.state.selected_month,
            selected_category: this.state.selected_category_value,
            selected_product: this.state.selected_product_value,
            party_master_id: this.state.party_master_id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            let emi_tenure_values = [];
            this.setState({
                emi_tenure_values: [],
                //selected_party: null
            });
            response.data.map((values, index) => {
                emi_tenure_values.push({tenure: values.tenure, count: values.scheme_emi_ten})
            });
            this.setState({
                emi_tenure_values: emi_tenure_values,
                loading: false
            }, () =>{
                console.log(emi_tenure_values);
                let chart = am4core.create("chartdiv", am4charts.PieChart);
                chart.data = this.state.emi_tenure_values;
                // chart.legend = new am4charts.Legend();
                // chart.legend.position = "right";
                // chart.legend.maxWidth= 100;

                // Add and configure Series
                let pieSeries = chart.series.push(new am4charts.PieSeries());
                pieSeries.dataFields.value = "count";
                pieSeries.dataFields.category = "tenure";
                chart.logo.height = -150;
            })
        });
    }

    generateChart2(){
        console.log("I am in gc2");
        axios.post(config.get('API_URL') + '/brandemi/get_customer_acq_values',{
            month: this.state.selected_month,
            selected_category: this.state.selected_category_value,
            selected_product: this.state.selected_product_value,
            party_master_id: this.state.party_master_id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            let cust_acq_values = [];
            this.setState({
                cust_acq_values: [],
                //selected_party: null
            });
            response.data.map((values, index) => {
                cust_acq_values.push({brand_amount: values.brand, bank_amount: values.bank, merchant_amount: values.merchant, innoviti_amount: values.innoviti})
            });
            this.setState({
                cust_acq_values: cust_acq_values,
                loading: false
            }, () =>{
                console.log(cust_acq_values);
                let chart2 = am4core.create("chartdiv2", am4charts.XYChart);
                chart2.logo.height = -150;
                chart2.data = this.state.cust_acq_values;
                console.log(this.state.cust_acq_values);
                console.log(this.state.cust_acq_values[0]['brand_amount']);
                chart2.data = [{
                "subvention": "Brand",
                "amount": this.state.cust_acq_values[0]['brand_amount']
                }, {
                "subvention": "Bank",
                "amount": this.state.cust_acq_values[0]['bank_amount']
                }, {
                "subvention": "Merchant",
                "amount": this.state.cust_acq_values[0]['merchant_amount']
                }, {
                "subvention": "Innoviti",
                "amount": this.state.cust_acq_values[0]['innoviti_amount']
                }];

                // Add and configure Series
                let categoryAxis = chart2.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "subvention";
                categoryAxis.title.text = "Subvention";
                categoryAxis.renderer.minGridDistance = 30;

                let valueAxis = chart2.yAxes.push(new am4charts.ValueAxis());
                valueAxis.title.text = "Amount (Rs.)";

                let series = chart2.series.push(new am4charts.ColumnSeries());
                series.name = "Customer Acq Cost";
                series.columns.template.tooltipText = "Series: {name}\nCategory: {categoryX}\nValue: {valueY}";
                series.columns.template.fill = am4core.color("#104547"); // fill
                series.dataFields.valueY = "amount";
                series.dataFields.categoryX = "subvention";
            })
        });
    }

    getSalesValue(){
        axios.post(config.get('API_URL')+'/brandemi/get_sales_agg', {
            month: this.state.selected_month,
            selected_category: this.state.selected_category_value,
            selected_product: this.state.selected_product_value,
            party_master_id: this.state.party_master_id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            response.data.map((value, index) => {
                this.setState({
                    sales_value: value.total_amount
                })
            })
            this.setState({
                loading:false
            })
        });
    }

    getCashbackValue(){
        axios.post(config.get('API_URL') + '/brandemi/get_cashback_agg',{
            month: this.state.selected_month,
            selected_category: this.state.selected_category_value,
            selected_product: this.state.selected_product_value,
            party_master_id: this.state.party_master_id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            response.data.map((value, index) => {
                this.setState({
                    cashback_value: value.total_amount
                })
            })
            this.setState({
                loading:false
            })
        });
    }

    generateCategory(){
        // const token = localStorage.usertoken;
        // const decoded = jwt_decode(token);
        axios.post(config.get('API_URL')+'/brandemi/get_dashboard_category', {
                selected_month: this.state.selected_month,
                party_master_id: this.state.party_master_id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {console.log(response);
            let category_list = [];
            this.setState({
                category_list: [],
                selected_category: null
            });
            response.data.map((values, index) => {
                category_list.push({value: values.dist_category, label: values.dist_category})
            });
            this.setState({
                category_list: category_list,
                loading: false
            })
        });
    }

    generateMerchant(){
        // const token = localStorage.usertoken;
        // const decoded = jwt_decode(token);
        axios.post(config.get('API_URL')+'/brandemi/get_dashboard_merchant', {
                selected_month: this.state.selected_month,
                party_master_id: this.state.party_master_id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {console.log(response);
            let merchant_list = [];
            this.setState({
                merchant_list: [],
                selected_merchant: null
            });
            response.data.map((values, index) => {
                merchant_list.push({value: values.dist_merchant, label: values.dist_merchant})
            });
            this.setState({
                merchant_list: merchant_list,
                loading: false
            })
        });
    }

    getChainList = () => {
        console.log(this.state.selected_merchant_value);
        axios.post(config.get('API_URL')+'/brandemi/get_dashboard_chain', {
                selected_merchant: this.state.selected_merchant_value,
                selected_month: this.state.selected_month,
                party_master_id: this.state.party_master_id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { console.log(response);
            let chain_list = [];
            this.setState({
                chain_list: [],
                selected_chain: null
            });
            response.data.map((values, index) => {
                chain_list.push({value: values.dist_chain, label: values.dist_chain})
            });
            this.setState({
                chain_list: chain_list,
                loading: false
            })
        });
    }

    getProductList = () => {
        console.log(this.state.selected_category_value);
        axios.post(config.get('API_URL')+'/brandemi/get_dashboard_product', {
                selected_category: this.state.selected_category_value,
                selected_month: this.state.selected_month,
                party_master_id: this.state.party_master_id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { console.log(response);
            let product_list = [];
            this.setState({
                product_list: [],
                selected_product: null
            });
            response.data.map((values, index) => {
                product_list.push({value: values.dist_product, label: values.dist_product})
            });
            this.setState({
                product_list: product_list,
                loading: false
            })
        });
    }

    updateCategory = (valuer) => {
            if(valuer == null){
                this.setState({
                    selected_category_value: [],
                    //selected_category: [{value: valuer.value, label: valuer.label}],
                    loading: true
                }, () => {
                    this.getProductList();
                    this.generateChart();
                    this.generateChart2();
                    this.getSalesValue();
                    this.getCashbackValue();
                    //this.getTATValue();
                    this.getTenureValue();
                    //this.getBrandUploadedData();
                });
            }
            else{
                this.setState({
                    selected_category_value: valuer,
                    //selected_category: [{value: valuer.value, label: valuer.label}],
                    loading: true
                }, () => {
                    this.getProductList();
                    this.generateChart();
                    this.generateChart2();
                    this.getSalesValue();
                    this.getCashbackValue();
                    //this.getTATValue();
                    this.getTenureValue();
                    //this.getBrandUploadedData();
                });
            }
    };

    getTenureValue(){
        
        axios.post(config.get('API_URL') + '/brandemi/get_emi_tenure_agg',{
            month: this.state.selected_month,
            selected_category: this.state.selected_category_value,
            selected_product: this.state.selected_product_value,
            party_master_id: this.state.party_master_id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            let tenures_val = [];
            response.data.map((values, index) => {
                tenures_val.push({tenure: values.tenure, amount: values.total_amount})
            });
            this.setState({
                tenures_val: tenures_val,
                loading: false
            })
        });
    }

    updateProduct = (valuer) => {
        if(valuer == null){
            this.setState({
                selected_product_value: [],
                //selected_product: [{value: valuer.value, label: valuer.label}],
                loading: true
            }, () => {
                this.generateChart();
                this.generateChart2();
                this.getSalesValue();
                this.getCashbackValue();
                //this.getTATValue();
                this.getTenureValue();
                //this.getBrandUploadedData();
            });
        }
        else{
            this.setState({
                selected_product_value: valuer,
                //selected_product: [{value: valuer.value, label: valuer.label}],
                loading: true
            }, () => {
                this.generateChart();
                this.generateChart2();
                this.getSalesValue();
                this.getCashbackValue();
                //this.getTATValue();
                this.getTenureValue();
                //this.getBrandUploadedData();
            });
        }
        
        
    };

    updateMerchant = (valuer) => {
        if(valuer == null){
            this.setState({
                selected_merchant_value: [],
                //selected_category: [{value: valuer.value, label: valuer.label}],
                loading: true
            }, () => {
                this.getChainList();
                this.generateChart();
                this.generateChart2();
                this.getSalesValue();
                this.getCashbackValue();
                //this.getTATValue();
                this.getTenureValue();
                //this.getBrandUploadedData();
            });
        }
        else{
            this.setState({
                selected_merchant_value: valuer,
                //selected_category: [{value: valuer.value, label: valuer.label}],
                loading: true
            }, () => {
                this.getChainList();
                this.generateChart();
                this.generateChart2();
                this.getSalesValue();
                this.getCashbackValue();
                //this.getTATValue();
                this.getTenureValue();
                //this.getBrandUploadedData();
            });
        }
        
};

    updateChain = (valuer) => {
        if(valuer == null){
            this.setState({
                selected_chain_value: [],
                //selected_product: [{value: valuer.value, label: valuer.label}],
                
                loading: true
            }, () => {
                this.generateChart();
                this.generateChart2();
                this.getSalesValue();
                this.getCashbackValue();
                //this.getTATValue();
                this.getTenureValue();
                //this.getBrandUploadedData();
            });
        }
        else{
            this.setState({
                selected_chain_value: valuer,
                //selected_product: [{value: valuer.value, label: valuer.label}],
                
                loading: true
            }, () => {
                this.generateChart();
                this.generateChart2();
                this.getSalesValue();
                this.getCashbackValue();
                //this.getTATValue();
                this.getTenureValue();
                //this.getBrandUploadedData();
            });
        }
    };

    get_dashboard_type(dash){
        axios.get(config.get('API_URL')+'/reportdashboard/get-dashboard-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                dashboard_id: dash
            }
        }).then(response => {
            this.setState({
                last_updated:response.data.data_updated_at
            })
            this.filter_permission(response.data.dashboard_type, dash);
        });
    }

    filter_permission(dash_type, dashId){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);


        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });

        if(dash_type=='Merchant') {
            if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
                this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
                this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
                this.setState({
                    merchant_list_box: true,
                    chain_list_box: true,
                    store_list_box: true,
                    acq_bank_list_box: false,
                })
                this.get_dash_details(dashId, '','', this.state.yestSend, this.state.todSend)
            }
            else if(decoded.object_type=='Merchant') {
                var merchantData = [{"value":decoded.object_code, "label":""}]
                this.getChain(decoded.object_code, 'merchant', decoded.object_type, decoded.object_code);
                this.getStore(decoded.object_code, 'merchant', decoded.object_type, decoded.object_code);
                this.changeMerchant('merchant', merchantData);
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: true,
                    store_list_box: true,
                    acq_bank_list_box: false,
                })
            }
            else if(decoded.object_type=='Chain') {
                // this.getChain(decoded.object_code, 'merchant', decoded.object_type, decoded.object_code);
                this.getStore(decoded.object_code, 'chain', decoded.object_type, decoded.object_code);
                var chainData = [{"value":decoded.object_code, "label":""}]
                this.changeChain('chain', chainData);
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: false,
                    store_list_box: true,
                    acq_bank_list_box: false,
                })
            }
            else if(decoded.object_type=='Store') {
                var storeData = [{"value":decoded.object_code, "label":""}]
                this.changeStore(storeData);
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: false,
                    store_list_box: false,
                    acq_bank_list_box: false,
                })
            }
            else{
                this.unauthorize_access();
            }
        } else if(dash_type=='Acquirer') {
            if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: false,
                    store_list_box: false,
                    acq_bank_list_box: true,
                })
                this.get_dash_details(dashId, '','', this.state.yestSend, this.state.todSend)
            }
            else if(decoded.object_type=='Acquirer Bank') {
                var storeData = [{"value":decoded.object_code, "label":""}]
                this.change_acq_banks(storeData);
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: false,
                    store_list_box: false,
                    acq_bank_list_box: false,
                })
            }
            else{
                this.unauthorize_access();
            }
        }
    }


    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";

    }
    _get_acq_banks() {
        axios.get(config.get('API_URL')+'/reports/acq-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(response.data.data != null) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading: false
        })
    }
    change_acq_banks(optionSelected) {
        //console.log(optionSelected);
        let value = '';
        let acqBankArray = [];
        if (optionSelected.length<1) {
            value = null;
            acqBankArray = '';
        } else {
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        this.setState({
            acqBankIds: acqBankArray,
            acqBankValue: optionSelected,
        });

        this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,this.state.frequency,
        //     this.state.yestSend, this.state.todSend);
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.merchantList.findIndex(obj => obj.value==mids.value);
                this.state.merchantList.move(index,0).join(',');
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: []
        });
        this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                this.state.chainList.move(index,0).join(',');
            });
        }

        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: []
        });

        this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        }

    }
    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/reports/get-store-filter/', {
            code: code,
            type: type,
            object_type: object_type,
            object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }
    changeStore(optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                this.state.storeList.move(index,0).join(',');
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
        //     this.state.yestSend, this.state.todSend);
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){

            this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
            // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds, this.state.frequency,
            //     this.state.yestSend, this.state.todSend)
        }
    }
    handleFromChange = date => { //alert(date);
        var parsed = queryString.parse(this.props.location.search);
        let dashId = parsed.dashId;
        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            startDate: date_filter
        });
        this.get_dash_details(dashId, this.state.object_type, this.state.object_code, date_filter)
    };

    get_dash_details(dashId, party_type, party_code, startDate, endDate){

        axios.get(config.get('API_URL') + '/reportdashboard/getDashboardDetails/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                dashboard_id: dashId
            }
        }).then(response => {

            this.setState({
                chart_data: [],
                kpiData:[]
            });
            var chartCount = 0;
            var kpiCount = 0;
            response.data.map((kdata, index) => {
                if (kdata.ui_component_type === 'kpi') {
                    this.getKPI(kdata.kpi_id, party_type, party_code, kpiCount, startDate, endDate);
                    this.setState({kpiData: [...this.state.kpiData, ""]})
                    kpiCount++;
                } else if (kdata.ui_component_type === 'chart') {
                    this.getChart(kdata.chart_id, party_type, party_code, chartCount, startDate, endDate);
                    this.setState({chart_data: [...this.state.chart_data, ""]})
                    chartCount++;
                }
            })
        });
    }

    getKPI(kpi_id, party_type, party_code, index, start_date, end_date) {

        // var mids = '';
        // var cids = '';
        // var sids = [25148];
        // var bids = '';
        // if(party_type=='Merchant') {
        //     mids = party_code;
        // } else if(party_type=='Chain') {
        //     cids = party_code;
        // } else if(party_type=='Store') {
        //     sids = party_code;
        // }
        // else if(party_type=='Acquirer Bank') {
        //     sids = party_code;
        // }
        //alert(this.state.merchantID)
        axios.post(config.get('API_URL') + '/reportdashboard/kpiDetails/', {

                kpi_id: kpi_id,
                mids: this.state.merchantID,
                cids: this.state.chainID,
                sids: this.state.storeID,
                bids: this.state.acqBankIds,
                start_date: start_date,
                end_date: end_date,
                object_type:this.state.object_type,
                object_code:this.state.object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            }).then(response => {
            var valueKpi = '';
            if (response.data.data !== null) {
                valueKpi = response.data.data[0];
                //this.setState({kpiData: [...this.state.kpiData, response.data.data[0]]})
            }
            // else {
            //     this.setState({kpiData: [...this.state.kpiData, ""]})
            // }
            let ab = this.state.kpiData.slice(); //creates the clone of the state
            ab[index] = valueKpi;
            // console.log('kpi data');
            // console.log(ab);

            this.setState({kpiData: ab});
        });
    }

    getChart(chart_id, party_type, party_code, index, start_date, end_date) {
        // var mids = '';
        // var cids = '';
        // var sids = [25148];
        // var bids = '';
        // if(party_type=='Merchant') {
        //     mids = party_code;
        // } else if(party_type=='Chain') {
        //     cids = party_code;
        // } else if(party_type=='Store') {
        //     sids = party_code;
        // }
        // else if(party_type=='Acquirer Bank') {
        //     sids = party_code;
        // }

        axios.post(config.get('API_URL') + '/reportdashboard/charts/', {
                chart_id: chart_id,
                mids: this.state.merchantID,
                cids: this.state.chainID,
                sids: this.state.storeID,
                bids: this.state.acqBankIds,
                start_date: start_date,
                end_date: end_date,
                object_type:this.state.object_type,
                object_code:this.state.object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            }).then(response => {
            var value = '';
            if (response.data.data !== null) {
                // console.log('chart details');
                // console.log(response.data.data);
                value = response.data.data[0];
            }
            // else {
            //    //this.setState({chart_data: [...this.state.chart_data, ""]})
            // }

            let a = this.state.chart_data.slice(); //creates the clone of the state
            a[index] = value;
            this.setState({chart_data: a});
        });
    }

    updateBrand = (valuer) => {

    }

    updateMonth = (valuer) => {
        this.setState({
            selected_month: valuer.value,
            selected_party_type2: [{value: valuer.value, label: valuer.label}],
            uploadDropdown: false,
            upload_user_type: 7,
            loading: true,
            selected_party: null,
            selected_party2: null,
            party_list: [],
            selected_product_value: [],
            selected_category_value: [],
            merchantValue: [],
            chainValue: []
        }, () => {
            this.generateCategory();
            this.generateMerchant();
            this.generateChart();
            this.generateChart2();
            this.getSalesValue();
            this.getCashbackValue();
            //this.getTATValue();
            this.getTenureValue();
        });
    };

    render() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        let brand_displayer = () => {
            if(decoded.userGroup == 1 || decoded.userGroup == '1'){
                return(
                    <div className="col-md-2 filter-bottom5 padd-5">
                    <label>Brand</label>
                    <Select className={"select-text-size"} name={"brand_selector"}
                        components={{ MenuList }}
                        defaultValue={this.state.default_brand}
                        onChange={this.updateBrand.bind(this)}
                        // styles={customStyles} className="report-listbox"
                        options={brand_render}
                        //placeholder="Select month"
                        // isClearable={true}
                    />
                </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }
        

        let category_render = this.state.category_list;
        let product_render = this.state.product_list;
        let merchant_render = this.state.merchant_list;
        let chain_render = this.state.chain_list;

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999})
        };
        let sales_amount = 0
        if(this.state.sales_value != null){
            sales_amount = (Number(this.state.sales_value)).toLocaleString('en-IN',{ minimumFractionDigits: 2 });
        }
        let cashback_amount = 0;
        if(this.state.cashback_value != null){
            cashback_amount = (Number(this.state.cashback_value)).toLocaleString('en-IN',{ minimumFractionDigits: 2 });
        }
        let kipeData = [{display_name: "Sales", display_unit: "₹ " + sales_amount, kpi_value: null, css_class: "pe-7s-cash text-success"},
                        {display_name: "Cashback Amount", display_unit: "₹ " + cashback_amount, kpi_value: null, css_class: "pe-7s-wallet text-success"},
                        {display_name: "API Success Rate", display_unit: "Coming Soon", kpi_value: null, css_class: "pe-7s-check text-success"},
                        {display_name: "Average Txn TAT", display_unit: "Coming Soon", kpi_value: null, css_class: "pe-7s-timer text-success"}
                    ];

        // let bindKPIData = this.state.kpiData.map((data, index) => {
        //     if(data==="")
        //     {
        //         return (
        //             <div className="col-lg-3 remove-footer " key={index}>
        //                 <div className="card linear-background"></div>
        //             </div>
        //         )
        //     }
        //     else {
        //         return (
        //             <div className="col-lg-3 remove-footer " key={index}>
        //                 <KPI title={data.display_name} amount={ (data.display_unit  === null ? '' : data.display_unit)  +' '+ ( data.kpi_value  === null ? '0' : numDifferentiation(data.kpi_value)) } cssClass={data.css_class  === 'null' ? '' : data.css_class}/>
        //             </div>
        //         )
        //     }
        // });
        let bindKPIData = kipeData.map((data, index) => {
            
            return (
                <div className="col-lg-3 remove-footer " key={index}>
                    <KPI title={data.display_name} amount={ (data.display_unit  === null ? '' : data.display_unit)  +' '+ ( data.kpi_value  === null ? '' : numDifferentiation(data.kpi_value)) } cssClass={data.css_class  === 'null' ? '' : data.css_class}/>
                </div>
            )
            
        });


        let charts_wizard = this.state.chart_data.map((chartData) => { //console.log(chartData)
            var charts = '';
            if (chartData.chart_type == 'Bar') {

                charts = <BarChart data={chartData.dataProvider} x_axis={chartData.x_axis[0]} y_axis={chartData.y_axis}
                                   chartHeight={this.state.chartHeight}/>

            } else if (chartData.chart_type == 'Pie of Pie') {


                charts = <PieofPieChart data={chartData.dataProvider} />

            } else if (chartData.chart_type == 'Pie') {
                charts =
                    <PieChart data={chartData.dataProvider} x_axis={chartData.x_axis[0]} y_axis={chartData.y_axis[0]}
                              chartHeight={this.state.chartHeight}/>
            } else if (chartData.chart_type == 'Line') {
                charts = <LineChart data={chartData.dataProvider} x_axis={numDifferentiation(chartData.x_axis[0])}
                                    y_axis={numDifferentiation(chartData.y_axis)}
                                    chartHeight={this.state.chartHeight}
                                    name={chartData.display_name}
                />
            } else if (chartData.chart_type == 'Column') {
                charts =
                    <ColumnChart data={chartData.dataProvider} x_axis={chartData.x_axis[0]} y_axis={chartData.y_axis}
                                 chartHeight={this.state.chartHeight}/>
            } else if (chartData.chart_type == 'StackColumn') {
                charts = <StackedColumnChart data={chartData.dataProvider} x_axis={numDifferentiation(chartData.x_axis[0])}
                                    y_axis={numDifferentiation(chartData.y_axis)}
                                    chartHeight={this.state.chartHeight}
                                    name={chartData.display_name}
                />
            }

            if (chartData !== "")
            {
                return (
                    <div className="col-md-6">
                        <div className="card">
                            <div className="dash-header">
                                <p className="dash-title">{chartData.display_name}</p>
                            </div>
                            <div className="ChartContent">
                                {charts}
                            </div>
                        </div>
                    </div>
                );
        }


        //     if(chartData==="")
        //     {
        //         return (
        //
        //             <div className="col-md-12">
        //                 <div className="card linear-background-chart">
        //                     <div className="dash-header">
        //
        //                         <p className="dash-title"></p>
        //                     </div>
        //                     <div className="ChartContent">
        //
        //                     </div>
        //                 </div>
        //             </div>
        //         )
        //     }
        //     else {
        //         return (
        //             <div className="col-md-12">
        //                 <div className="card">
        //                     <div className="dash-header">
        //
        //                         <p className="dash-title">{chartData.display_name}</p>
        //                     </div>
        //                     <div className="ChartContent">
        //                         {charts}
        //                     </div>
        //                 </div>
        //             </div>
        //         )
        //     }
         });

        return (
            <div className="content-invoice">
                <CommonNavbar/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                {/*<div className="col-md-12 no-padd">*/}
                                {/*    <div className="card title-card-bottom-space">*/}
                                {/*        <div className="header">*/}
                                {/*            <h4 className="title">Dashboard Details</h4>*/}
                                {/*            <p className="category"></p>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                {/*<hr/>*/}
                                <div className="content">

                                    {/*<div className="row">*/}
                                    {/*    <div className="">*/}
                                    {/*        <label className="leftLabel">Date Filter: </label>*/}
                                    {/*        <div className="rightBox">*/}
                                    {/*        <DatePicker*/}
                                    {/*            dateFormat="yyyy-MM-dd"*/}
                                    {/*            selected={Date.parse(this.state.startDate)}*/}
                                    {/*            onChange={this.handleFromChange}*/}
                                    {/*            maxDate={new Date()}*/}
                                    {/*        />*/}
                                    {/*         </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="row">
                                    {brand_displayer()}
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Date Filter</label>
                                        <Select className={"select-text-size"} name={"month_selector"}
                                            components={{ MenuList }}
                                            defaultValue={this.state.default_month}
                                            onChange={this.updateMonth.bind(this)}
                                            // styles={customStyles} className="report-listbox"
                                            options={month_render}
                                            //placeholder="Select month"
                                            // isClearable={true}
                                        />
                                    </div>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Category</label>
                                            <ReactMultiSelectCheckboxes name="category"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.selected_category_value}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.updateCategory.bind(this)}
                                                options={category_render}
                                                placeholderButtonLabel="All"
                                            />
                                        </div>

                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Product</label>
                                            <ReactMultiSelectCheckboxes name="product"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.selected_product_value}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.updateProduct.bind(this)}
                                                options={product_render}
                                                placeholderButtonLabel="Select [Product]"

                                            />
                                        </div>
                                    
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Merchants</label>
                                            <ReactMultiSelectCheckboxes name="merchants"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.selected_merchant_value}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.updateMerchant.bind(this)}
                                                options={merchant_render}
                                                placeholderButtonLabel="All"

                                            />
                                        </div>
                                        
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Chain </label>
                                                <ReactMultiSelectCheckboxes name="chain"
                                                    isMulti
                                                    value={this.state.selected_chain_value}
                                                    components={{ MenuList }}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.updateChain.bind(this)}
                                                    options={chain_render}
                                                    placeholderButtonLabel="Select [Chain]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            </div>
                                        
                                        {/* <div className="coll-md-4 pull-right dash-sync-con">
                                           <span
                                                className="dash-data-sync-sp"><span>Last updated: <b>{moment(this.state.last_updated).format('D MMM YYYY HH:mm:ss')}</b></span>
                                           </span>

                                        </div> */}
                                    

                                    </div>
                                    <div className="gap_ver"></div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        {/*<div className="col-md-12">*/}
                                        {bindKPIData}
                                        {/*</div>*/}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="dash-header">
                                                    <p className="dash-title">EMI Tenure</p>
                                                </div>
                                                <div id="chartdiv" style={{ width: "100%", height: "250px" }}></div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="dash-header">
                                                    <p className="dash-title">Customer Acquisiton Cost</p>
                                                </div>
                                                <div id="chartdiv2" style={{ width: "100%", height: "250px" }}></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {charts_wizard}
                                    </div>
                                    {/*<div className="col-md-6">*/}
                                    {/*    <div className="card">*/}
                                    {/*        <div className="header">*/}
                                    {/*            <h4 className="title">Stacked Column Chart</h4>*/}
                                    {/*            <p className="category">24 Hours performance</p>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="ChartContent">*/}
                                    {/*            <StackedColumnChart data = {this.state.data}/>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>

                                <div className="clearfix"></div>

                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
        );
    }
}

export default NewDashboard;